// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"88":"uploadDeviceFile","664":"findShip"}[chunkId] || chunkId) + "." + {"88":"cab28cee","664":"561e8cc0","905":"d166ea26"}[chunkId] + ".js";
};